import React from 'react';

import Button, {ButtonProps} from 'ui-library/buttons/Button';

import Clipboard from './Clipboard';

export interface CopyButtonProps extends ButtonProps {
  value?: string;
}

export default function CopyButton(props: CopyButtonProps): JSX.Element {
  return (
    <Clipboard value={props.value}>
      <Button {...props} icon={props.icon ? props.icon : 'copy'} />
    </Clipboard>
  );
}
